import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

export default function integrityCheck({
    items = [],
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(items);
    const story = items[0];

    if (!story) {
        messages.push("Must have a story");
    }

    if (!story.headline) {
        messages.push("Story must have a headline");
    }
    return messages;
}
